export let config = {};
config.jlcCsvUrl =
  "https://api.allorigins.win/raw?url=https://jlcpcb.com/componentSearch/uploadComponentInfo";
